export default "__VITE_ASSET__0778a562__"